export const HOME_PAGE = {
  ACCESS_DIALOG_PROJECT_NAME: 'homePageAccessDialogProjectName',
  ACCESS_DIALOG_PROJECT_NAME_TOOLTIP: 'homePageAccessDialogProjectNameTooltip',
  PROJECT_MOVE_BUTTON_CANCEL: 'home-page-project-move-button-cancel',
  PROJECT_MOVE_BUTTON_CONFIRM: 'home-page-project-move-button-confirm',
  CREATE_WORKING_SCHEDULE_CLOSE_BUTTON: 'createWorkingScheduleCloseButton',
  CREATE_WORKING_SCHEDULE_CANCEL_BUTTON: 'createWorkingScheduleCancelButton',
  ACCESS_DIALOG: 'homePageAccessDialog',
  ACCESS_DIALOG_CONTENT: 'homePageAccessDialogContent',
  ACCESS_DIALOG_OK_BUTTON: 'homePageAccessDialogOkButton',
  ACCESS_DIALOG_USER_ROW: 'homePageAccessDialogUserRow',
  ACCESS_DIALOG_USER_AVATAR: 'homePageAccessDialogUserAvatar',
  ACCESS_DIALOG_USER_NAME: 'homePageAccessDialogUserName',
  ACCESS_DIALOG_USER_ROLE: 'homePageAccessDialogUserRole',
  ALL_PROJECTS_ADD_FIELD_COLUMN_HEADER_BUTTON: 'allProjectsAddFieldColumnHeaderButton',
  ALL_PROJECTS_FIELDS_LIST_SUBHEADER: 'allProjectsFieldsListSubheader',
  ALL_PROJECTS_FIELD_ROW_BUTTON: 'allProjectsFieldRowButton',
  ALL_PROJECTS_FIELD_NAME_TOOLTIP: 'allProjectsFieldNameTooltip',
  ALL_PROJECTS_FIELD_NAME_TEXT: 'allProjectsFieldNameText',
  ALL_PROJECTS_FIELD_SWITCH: 'allProjectsFieldSwitch',
  ALL_PROJECTS_COLUMN_FIELDS_SELECTOR_POPOVER: 'allProjectsColumnFieldsSelectorPopover',
  ALL_PROJECTS_COLUMN_FIELD_SEARCH_BOX: 'allProjectsColumnFieldSearchBox',
  ALL_PROJECTS_COLUMN_FIELD_SEARCH_INPUT: 'allProjectsColumnFieldSearchInput',
  ALL_PROJECTS_COLUMN_FIELD_SEARCH_ICON: 'allProjectsColumnFieldSearchIcon',
  ALL_PROJECTS_COLUMN_FIELD_CLEAR_SEARCH: 'allProjectsColumnFieldClearSearch',
  ALL_PROJECTS_COLUMN_FIELDS_LIST: 'allProjectsColumnFieldsList',
  ALL_PROJECTS_COLUMN_FIELDS_NO_RESULTS: 'allProjectsColumnFieldsNoResults',
  ALL_PROJECTS_COLUMN_FIELDS_DIVIDER: 'allProjectsColumnFieldsDivider',
  ALL_PROJECTS_CUSTOM_COLUMN_HEADER: 'allProjectsCustomColumnHeader',
  ALL_PROJECTS_CUSTOM_COLUMN_MENU_BUTTON: 'allProjectsCustomColumnMenuButton',
  ALL_PROJECTS_CUSTOM_COLUMN_POPPER: 'allProjectsCustomColumnPopper',
  ALL_PROJECTS_CUSTOM_COLUMN_MENU_CONTAINER: 'allProjectsCustomColumnMenuContainer',
  ALL_PROJECTS_CUSTOM_COLUMN_MENU_LIST: 'allProjectsCustomColumnMenuList',
  ALL_PROJECTS_CUSTOM_COLUMN_HIDE_FIELD_MENU_ITEM: 'allProjectsCustomColumnHideFieldMenuItem',
  ALL_PROJECTS_CUSTOM_COLUMN_MENU_DIVIDER: 'allProjectsCustomColumnMenuDivider',
  ALL_PROJECTS_CUSTOM_COLUMN_INSERT_LEFT_MENU_ITEM: 'allProjectsCustomColumnInsertLeftMenuItem',
  ALL_PROJECTS_CUSTOM_COLUMN_INSERT_RIGHT_MENU_ITEM: 'allProjectsCustomColumnInsertRightMenuItem',
  ALL_PROJECTS_TABLE_NAME_CELL_RENDERER: 'allProjectsTableNameCellRenderer',
  ALL_PROJECTS_TABLE_NAME_CELL_TOOLTIP: 'allProjectsTableNameCellTooltip',
  ALL_PROJECTS_TABLE_NAME_CELL_PROJECT_TYPE: 'allProjectsTableNameCellProjectType',
  ALL_PROJECTS_TABLE_NAME_CELL_PROJECT_COLOR: 'allProjectsTableNameCellProjectColor',
  ALL_PROJECTS_TABLE_NAME_CELL_PROJECT_NAME: 'allProjectsTableNameCellProjectName',
  ALL_PROJECTS_TABLE_NAME_CELL_USERS_POPOVER: 'allProjectsTableNameCellUsersPopover',
  ALL_PROJECTS_TABLE_NAME_CELL_MORE_MENU: 'allProjectsTableNameCellMoreMenu',
  ALL_PROJECTS_TABLE_ORG_FIELD_CELL_TOOLTIP: 'allProjectsTableOrgFieldCellTooltip',
  ALL_PROJECTS_TABLE_ORG_FIELD_USER_TYPE: 'allProjectsTableOrgFieldUserType',
  ALL_PROJECTS_TABLE_ORG_FIELD_USER_AVATAR: 'allProjectsTableOrgFieldUserAvatar',
  ALL_PROJECTS_TABLE_ORG_FIELD_USER_NAME_TOOLTIP: 'allProjectsTableOrgFieldUserNameTooltip',
  ALL_PROJECTS_TABLE_ORG_FIELD_USER_NAME: 'allProjectsTableOrgFieldUserName',
  ALL_PROJECTS_TABLE_ORG_FIELD_OPTION_CHIP: 'allProjectsTableOrgFieldOptionChip',
  ALL_PROJECTS_TABLE_STATUS_VERSION_NODE_TAG: 'allProjectsTableStatusVersionNodeTag',
  ALL_PROJECTS_TABLE_STATUS_CHEVRON_ICON: 'allProjectsTableStatusChevronIcon',
  ALL_PROJECTS_TABLE_STATUS_EMPTY_VALUE: 'allProjectsTableStatusEmptyValue',
  ALL_PROJECTS_TABLE_TYPE_VERSION_NODE_TAG: 'allProjectsTableTypeVersionNodeTag',
  ALL_PROJECTS_TABLE_TYPE_CHEVRON_ICON: 'allProjectsTableTypeChevronIcon',
  ALL_PROJECTS_TABLE_TYPE_EMPTY_VALUE: 'allProjectsTableTypeEmptyValue',
  ALL_PROJECTS_TABLE_VERSION_TOOLTIP: 'allProjectsTableVersionTooltip',
  ALL_PROJECTS_TABLE_VERSION_TEXT: 'allProjectsTableVersionText',
  PROJECT_TYPE_PILL: 'projectTypePill',
  ALL_PROJECTS_TABLE_GRID: 'allProjectsTableGrid',
  ALL_PROJECTS_TABLE_COLUMN_FIELDS_SELECTOR_POPUP: 'allProjectsTableColumnFieldsSelectorPopup',
  ALL_PROJECTS_VIEW_DELETE_DIALOG: 'allProjectsViewDeleteDialog',
  ALL_PROJECTS_VIEW_DELETE_DIALOG_CLOSE_BUTTON: 'allProjectsViewDeleteDialogCloseButton',
  ALL_PROJECTS_VIEW_DELETE_DIALOG_TITLE: 'allProjectsViewDeleteDialogTitle',
  ALL_PROJECTS_VIEW_DELETE_DIALOG_CONTENT: 'allProjectsViewDeleteDialogContent',
  ALL_PROJECTS_VIEW_DELETE_DIALOG_ACTIONS: 'allProjectsViewDeleteDialogActions',
  ALL_PROJECTS_VIEW_DELETE_DIALOG_NO_BUTTON: 'allProjectsViewDeleteDialogNoButton',
  ALL_PROJECTS_VIEW_DELETE_DIALOG_YES_BUTTON: 'allProjectsViewDeleteDialogYesButton',
  ALL_PROJECTS_VIEW_NAME_DIALOG: 'allProjectsViewNameDialog',
  ALL_PROJECTS_VIEW_NAME_DIALOG_CLOSE_BUTTON: 'allProjectsViewNameDialogCloseButton',
  ALL_PROJECTS_VIEW_NAME_DIALOG_TITLE: 'allProjectsViewNameDialogTitle',
  ALL_PROJECTS_VIEW_NAME_DIALOG_CONTENT: 'allProjectsViewNameDialogContent',
  ALL_PROJECTS_VIEW_NAME_DIALOG_INPUT: 'allProjectsViewNameDialogInput',
  ALL_PROJECTS_VIEW_NAME_DIALOG_ACTIONS: 'allProjectsViewNameDialogActions',
  ALL_PROJECTS_VIEW_NAME_DIALOG_CANCEL_BUTTON: 'allProjectsViewNameDialogCancelButton',
  ALL_PROJECTS_VIEW_NAME_DIALOG_SAVE_BUTTON: 'allProjectsViewNameDialogSaveButton',
  ALL_PROJECTS_VIEW_WRAPPER: 'allProjectsViewWrapper',
  ALL_PROJECTS_VIEW_MENU_TRIGGER: 'allProjectsViewMenuTrigger',
  ALL_PROJECTS_VIEW_NAME: 'allProjectsViewName',
  ALL_PROJECTS_VIEW_CHEVRON_ICON: 'allProjectsViewChevronIcon',
  ALL_PROJECTS_VIEW_POPPER: 'allProjectsViewPopper',
  ALL_PROJECTS_VIEW_SEARCH_WRAPPER: 'allProjectsViewSearchWrapper',
  ALL_PROJECTS_VIEW_SEARCH_ICON: 'allProjectsViewSearchIcon',
  ALL_PROJECTS_VIEW_SEARCH_INPUT: 'allProjectsViewSearchInput',
  ALL_PROJECTS_VIEW_CLEAR_SEARCH: 'allProjectsViewClearSearch',
  ALL_PROJECTS_VIEW_MENU_SCROLL: 'allProjectsViewMenuScroll',
  ALL_PROJECTS_VIEW_MENU_SEPARATOR: 'allProjectsViewMenuSeparator',
  ALL_PROJECTS_VIEW_RESTORE_DEFAULT: 'allProjectsViewRestoreDefault',
  ALL_PROJECTS_VIEW_BUTTON_WRAPPER: 'allProjectsViewButtonWrapper',
  ALL_PROJECTS_VIEW_BUTTON: 'allProjectsViewButton',
  ALL_PROJECTS_VIEW_BUTTON_TEXT: 'allProjectsViewButtonText',
  ALL_PROJECTS_VIEW_MENU_ITEM: 'allProjectsViewMenuItem',
  ALL_PROJECTS_VIEW_MENU_NAME_TOOLTIP: 'allProjectsViewMenuNameTooltip',
  ALL_PROJECTS_VIEW_MENU_NAME: 'allProjectsViewMenuName',
  ALL_PROJECTS_VIEW_SUBMENU_WRAPPER: 'allProjectsViewSubmenuWrapper',
  ALL_PROJECTS_VIEW_SUBMENU_TRIGGER: 'allProjectsViewSubmenuTrigger',
  ALL_PROJECTS_VIEW_SUBMENU_ICON: 'allProjectsViewSubmenuIcon',
  ALL_PROJECTS_VIEW_SUBMENU_POPPER: 'allProjectsViewSubmenuPopper',
  ALL_PROJECTS_VIEW_SUBMENU_ITEMS: 'allProjectsViewSubmenuItems',
  ALL_PROJECTS_VIEW_SUBMENU_RENAME: 'allProjectsViewSubmenuRename',
  ALL_PROJECTS_VIEW_SUBMENU_RENAME_ICON: 'allProjectsViewSubmenuRenameIcon',
  ALL_PROJECTS_VIEW_SUBMENU_DUPLICATE: 'allProjectsViewSubmenuDuplicate',
  ALL_PROJECTS_VIEW_SUBMENU_DUPLICATE_ICON: 'allProjectsViewSubmenuDuplicateIcon',
  ALL_PROJECTS_VIEW_SUBMENU_DELETE: 'allProjectsViewSubmenuDelete',
  ALL_PROJECTS_VIEW_SUBMENU_DELETE_ICON: 'allProjectsViewSubmenuDeleteIcon',
  ALL_PROJECTS_VIEW_SELECTED_ICON: 'allProjectsViewSelectedIcon',
  CREATE_WORKING_SCHEDULE_DIALOG: 'createWorkingScheduleDialog',
  CREATE_WORKING_SCHEDULE_CLOSE_ICON: 'createWorkingScheduleCloseIcon',
  CREATE_WORKING_SCHEDULE_DATE_PICKER: 'createWorkingScheduleDatePicker',
  CREATE_WORKING_SCHEDULE_ERROR_TOOLTIP: 'createWorkingScheduleErrorTooltip',
  CREATE_WORKING_SCHEDULE_CLEAR_INPUT: 'createWorkingScheduleClearInput',
  CREATE_WORKING_SCHEDULE_ACTIONS: 'createWorkingScheduleActions',
  CREATE_WORKING_SCHEDULE_CREATE_BUTTON: 'createWorkingScheduleCreateButton',
  IMPORT_MS_ELEMENTS_CLOSE_BUTTON: 'importMSElementsCloseButton',
  IMPORT_MS_ELEMENTS_CLOSE_ICON: 'importMSElementsCloseIcon',
  IMPORT_MS_ELEMENTS_VERSION_DROPDOWN: 'importMSElementsVersionDropdown',
  IMPORT_MS_ELEMENTS_ACTIONS: 'importMSElementsActions',
  IMPORT_MS_ELEMENTS_BACK_BUTTON: 'importMSElementsBackButton',
  IMPORT_MS_ELEMENTS_NEXT_BUTTON: 'importMSElementsNextButton',
  MASTER_VS_WORKING_SELECTION_CLOSE_ICON: 'masterVsWorkingSelectionCloseIcon',
  MASTER_VS_WORKING_SELECTION_ACTIONS: 'masterVsWorkingSelectionActions',
  MASTER_VS_WORKING_SELECTION_MASTER_OPTION: 'masterVsWorkingSelectionMasterOption',
  MASTER_VS_WORKING_SELECTION_WORKING_OPTION: 'masterVsWorkingSelectionWorkingOption',
  NAME_WS_VERSION_CLOSE_BUTTON: 'nameWSVersionCloseButton',
  NAME_WS_VERSION_CLOSE_ICON: 'nameWSVersionCloseIcon',
  NAME_WS_VERSION_NAME_INPUT: 'nameWSVersionNameInput',
  NAME_WS_VERSION_ACTIONS: 'nameWSVersionActions',
  NAME_WS_VERSION_CANCEL_BUTTON: 'nameWSVersionCancelButton',
  NAME_WS_VERSION_NEXT_BUTTON: 'nameWSVersionNextButton',
  NEW_VS_EXISTING_CLOSE_BUTTON: 'newVsExistingCloseButton',
  NEW_VS_EXISTING_CLOSE_ICON: 'newVsExistingCloseIcon',
  NEW_VS_EXISTING_PLANERA_OPTION: 'newVsExistingPlaneraOption',
  NEW_VS_EXISTING_P6_OPTION: 'newVsExistingP6Option',
  NEW_VS_EXISTING_NEW_OPTION: 'newVsExistingNewOption',
  NEW_VS_EXISTING_CREATE_BUTTON: 'newVsExistingCreateButton',
  PROJECT_LIST_GO_BACK: 'projectListGoBack',
  PROJECT_LIST_CLOSE_BUTTON: 'projectListCloseButton',
  PROJECT_LIST_CLOSE_ICON: 'projectListCloseIcon',
  PROJECT_LIST_SEARCH_INPUT: 'projectListSearchInput',
  PROJECT_LIST_RECENT_PROJECTS_ITEM: 'projectListRecentProjectsItem',
  PROJECT_LIST_WORKSPACE_ITEM: 'projectListWorkspaceItem',
  PROJECT_LIST_SORT_DROPDOWN: 'projectListSortDropdown',
  PROJECT_LIST_PROJECT_CARD: 'projectListProjectCard',
  PROJECT_LIST_NO_MATCHING_RESULTS: 'projectListNoMatchingResults',
  TIMESLICE_BAR_CONTAINER: 'timesliceBarContainer',
  TIMESLICE_BAR_FLEX: 'timesliceBarFlex',
  TIMESLICE_BAR_LEFT_DATE: 'timesliceBarLeftDate',
  TIMESLICE_BAR_LEGEND_CONTAINER: 'timesliceBarLegendContainer',
  TIMESLICE_BAR_RIGHT_DATE: 'timesliceBarRightDate',
  TIMESLICE_BAR_LEGEND_WRAPPER: 'timesliceBarLegendWrapper',
  WORKING_SCHEDULE_FROM_EXISTING_DIALOG: 'workingScheduleFromExistingDialog',
  WORKING_SCHEDULE_FROM_EXISTING_DATES_COMPONENT: 'workingScheduleFromExistingDatesComponent',
  WORKING_SCHEDULE_FROM_EXISTING_IMPORT_COMPONENT: 'workingScheduleFromExistingImportComponent',
  WORKING_SCHEDULE_OPTION_CONTAINER: 'workingScheduleOptionContainer',
  WORKING_SCHEDULE_OPTION_HEADER: 'workingScheduleOptionHeader',
  WORKING_SCHEDULE_OPTION_ICON_TITLE: 'workingScheduleOptionIconTitle',
  WORKING_SCHEDULE_OPTION_WORKING_ICON: 'workingScheduleOptionWorkingIcon',
  WORKING_SCHEDULE_OPTION_MASTER_ICON: 'workingScheduleOptionMasterIcon',
  WORKING_SCHEDULE_OPTION_CHECK: 'workingScheduleOptionCheck',
  WORKING_SCHEDULE_OPTION_BODY: 'workingScheduleOptionBody',
  WS_VERSION_DATES_CLOSE_BUTTON: 'wsVersionDatesCloseButton',
  WS_VERSION_DATES_CLOSE_ICON: 'wsVersionDatesCloseIcon',
  WS_VERSION_DATES_DATE_PICKER: 'wsVersionDatesDatePicker',
  WS_VERSION_DATES_WEEKS_TOOLTIP: 'wsVersionDatesWeeksTooltip',
  WS_VERSION_DATES_WEEKS_INPUT: 'wsVersionDatesWeeksInput',
  WS_VERSION_DATES_CLEAR_INPUT: 'wsVersionDatesClearInput',
  WS_VERSION_DATES_ACTIONS: 'wsVersionDatesActions',
  WS_VERSION_DATES_CANCEL_BUTTON: 'wsVersionDatesCancelButton',
  WS_VERSION_DATES_CREATE_BUTTON: 'wsVersionDatesCreateButton',
  IMPORT_FIXES_GROUP_CONTAINER: 'ImportFixesGroupContainer',
  IMPORT_FIXES_DIALOG_SECTION: 'ImportFixesDialogSection',
  IMPORT_FIXES_ISSUE_COUNTER: 'ImportFixesIssueCounter',
  IMPORT_FIXES_ISSUE_WRAPPER: 'ImportFixesIssueWrapper',
  IMPORT_FIXES_NOTE_TITLE: 'ImportFixesNoteTitle',
  IMPORT_FIXES_NOTE_DESCRIPTION: 'ImportFixesNoteDescription',
  IMPORT_FIXES_ORDERED_LIST: 'ImportFixesOrderedList',
  IMPORT_FIXES_CHECKBOX_CONTAINER: 'ImportFixesCheckboxContainer',
  IMPORT_FIXES_RADIO_BUTTON_CONTAINER: 'ImportFixesRadioButtonContainer',
  IMPORT_FIXES_CHECKBOX_ROW: 'ImportFixesCheckboxRow',
  IMPORT_FIXES_CHECKBOX_INPUT: 'ImportFixesCheckboxInput',
  IMPORT_FIXES_CHECKBOX_LABEL: 'ImportFixesCheckboxLabel',
  IMPORT_FIXES_DATE_PICKER_ROW: 'ImportFixesDatePickerRow',
  IMPORT_FIXES_DATE_PICKER_INPUT: 'ImportFixesDatePickerInput',
  IMPORT_FIXES_DATE_PICKER_LABEL: 'ImportFixesDatePickerLabel',
  IMPORT_FIXES_RADIO_BUTTON_ROW: 'ImportFixesRadioButtonRow',
  IMPORT_FIXES_RADIO_BUTTON_INPUT: 'ImportFixesRadioButtonInput',
  IMPORT_FIXES_RADIO_BUTTON_LABEL: 'ImportFixesRadioButtonLabel',
  IMPORT_FIXES_SUB_LEVEL_OPTIONS: 'ImportFixesSubLevelOptions',
  IMPORT_FIXES_BREADCRUMB_ISSUES: 'ImportFixesBreadcrumbIssues',
  PROJECT_IMPORT_DIALOG: 'ProjectImportDialog',
  PROJECT_IMPORT_CLOSE_BUTTON: 'ProjectImportCloseButton',
  PROJECT_IMPORT_CLOSE_ICON: 'ProjectImportCloseIcon',
  PROJECT_IMPORT_ERROR_CONTAINER: 'ProjectImportErrorContainer',
  PROJECT_IMPORT_UPLOAD_ANYWAY_LINK: 'ProjectImportUploadAnywayLink',
  PROJECT_IMPORT_DROPZONE: 'ProjectImportDropzone',
  PROJECT_IMPORT_FILE_INPUT: 'ProjectImportFileInput',
  PROJECT_IMPORT_UPLOAD_BUTTON: 'ProjectImportUploadButton',
  PROJECT_IMPORT_ICON: 'ProjectImportIcon',
  HOMEPAGE_CARD: 'HomepageCard',
  HOMEPAGE_CARD_ICON_BOX: 'HomepageCardIconBox',
  HOMEPAGE_CARD_TITLE: 'HomepageCardTitle',
  HOMEPAGE_CARD_DESCRIPTION: 'HomepageCardDescription',
  NEW_HOMEPAGE_WRAPPER: 'NewHomepageWrapper',
  NEW_HOMEPAGE_CARD_SECTION: 'NewHomepageCardSection',
  NEW_HOMEPAGE_PROJECTS_REPORTS_SECTION: 'NewHomepageProjectsReportsSection',
  NEW_HOMEPAGE_RECENT_PROJECTS_TITLE: 'NewHomepageRecentProjectsTitle',
  NEW_HOMEPAGE_PROJECTS_REPORTS_TITLE: 'NewHomepageProjectsReportsTitle',
  NEW_HOMEPAGE_CARDS_CONTAINER: 'NewHomepageCardsContainer',
  NEW_HOMEPAGE_USERS_LIBRARIES_TITLE: 'NewHomepageUsersLibrariesTitle',
  NEW_HOMEPAGE_COMMENT_SECTION: 'NewHomepageCommentSection',
  NEW_HOMEPAGE_COMMENTS: 'NewHomepageComments',
  NEW_HOMEPAGE_CONTAINER: 'NewHomepageContainer',
  NEW_HOMEPAGE_BREADCRUMBS: 'NewHomepageBreadcrumbs',
  NEW_HOMEPAGE_BREADCRUMB_HOME_ITEM: 'NewHomepageBreadcrumbHomeItem',
  NEW_HOMEPAGE_HOME_ICON: 'NewHomepageHomeIcon',
  NEW_HOMEPAGE_HOME_TEXT: 'NewHomepageHomeText',
  NEW_HOMEPAGE_GREATER_THAN_ICON: 'NewHomepageGreaterThanIcon',
  NEW_HOMEPAGE_BREADCRUMB_ITEM: 'NewHomepageBreadcrumbItem',
  NEW_HOMEPAGE_DIVIDER: 'NewHomepageDivider',
  NEW_HOMEPAGE_PAGE_DESCRIPTION: 'NewHomepagePageDescription',
  NEW_HOMEPAGE_PAGE_TITLE: 'NewHomepagePageTitle',
  NEW_HOMEPAGE_PAGE_DESC: 'NewHomepagePageDesc',
  NEW_HOMEPAGE_PROJECTS_WRAPPER: 'NewHomepageProjectsWrapper',
  NEW_HOMEPAGE_HOMEPAGE_CONTENTS: 'NewHomepageHomepageContents',
  NEW_HOMEPAGE_PROJECTS_LIST: 'NewHomepageProjectsList',
  NEW_HOMEPAGE_PROJECT_CARD_MORE_MENU: 'NewHomepageProjectCardMoreMenu',
  RECENT_PROJECTS_SECTION: 'RecentProjectsSection',
  RECENT_PROJECT_CARD: 'RecentProjectCard',
  PROJECT_CARD_MORE_MENU: 'ProjectCardMoreMenu',
  PROJECT_CARD_MORE_MENU_RENAME_ITEM: 'ProjectCardMoreMenuRenameItem',
  PROJECT_CARD_MORE_MENU_MEMBERS_ITEM: 'ProjectCardMoreMenuMembersItem',
  PROJECT_CARD_MORE_MENU_MOVE_TO_ITEM: 'ProjectCardMoreMenuMoveToItem',
  PROJECT_CARD_MORE_MENU_EXPORT_ITEM: 'ProjectCardMoreMenuExportItem',
  PROJECT_CARD_MORE_MENU_DUPLICATE_ITEM: 'ProjectCardMoreMenuDuplicateItem',
  PROJECT_CARD_MORE_MENU_DELETE_ITEM: 'ProjectCardMoreMenuDeleteItem',
  PROJECT_CARD_MORE_MENU_RENAME_ICON: 'ProjectCardMoreMenuRenameIcon',
  PROJECT_CARD_MORE_MENU_MEMBERS_ICON: 'ProjectCardMoreMenuMembersIcon',
  PROJECT_CARD_MORE_MENU_MOVE_TO_ICON: 'ProjectCardMoreMenuMoveToIcon',
  PROJECT_CARD_MORE_MENU_EXPORT_ICON: 'ProjectCardMoreMenuExportIcon',
  PROJECT_CARD_MORE_MENU_DUPLICATE_ICON: 'ProjectCardMoreMenuDuplicateIcon',
  PROJECT_CARD_MORE_MENU_DELETE_ICON: 'ProjectCardMoreMenuDeleteIcon',
  PROJECT_CARD_MORE_MENU_CARET_RIGHT: 'ProjectCardMoreMenuCaretRight',
  PROJECT_CARD_MORE_MENU_RENAME_TEXT: 'ProjectCardMoreMenuRenameText',
  PROJECT_CARD_MORE_MENU_MEMBERS_TEXT: 'ProjectCardMoreMenuMembersText',
  PROJECT_CARD_MORE_MENU_MOVE_TO_TEXT: 'ProjectCardMoreMenuMoveToText',
  PROJECT_CARD_MORE_MENU_EXPORT_TEXT: 'ProjectCardMoreMenuExportText',
  PROJECT_CARD_MORE_MENU_DUPLICATE_TEXT: 'ProjectCardMoreMenuDuplicateText',
  PROJECT_CARD_MORE_MENU_DELETE_TEXT: 'ProjectCardMoreMenuDeleteText',
  PROJECT_CARD_MORE_MENU_ICON_CONTAINER: 'ProjectCardMoreMenuIconContainer',
  FIELD_SCHEDULE_INFO_CONTAINER: 'FieldScheduleInfoContainer',
  FIELD_SCHEDULE_LEARN_MORE_BUTTON: 'FieldScheduleLearnMoreButton',
  PROJECT_CONFIGURATION_CLEAR_NAME_ICON: 'ProjectConfigurationClearNameIcon',
  TIME_SLICE_SECTION_DATE_PICKER: 'TimeSliceSectionDatePicker',
  TIME_SLICE_SECTION_WEEKS_INPUT: 'TimeSliceSectionWeeksInput',
  TIME_SLICE_SECTION_MINUS_BUTTON: 'TimeSliceSectionMinusButton',
  TIME_SLICE_SECTION_PLUS_BUTTON: 'TimeSliceSectionPlusButton',
  FIELD_SCHEDULE_CARD: 'FieldScheduleCard',
  FIELD_SCHEDULE_CARD_TICK_ICON: 'FieldScheduleCardTickIcon',
  FIELD_SCHEDULE_CREATE_VERSION_SELECT: 'FieldScheduleCreateVersionSelect',
  FIELD_SCHEDULE_CREATE_VERSION_MENU_ITEM: 'FieldScheduleCreateVersionMenuItem',
  FIELD_SCHEDULE_CREATE_VERSION_NEXT_BUTTON: 'FieldScheduleCreateVersionNextButton',
  FIELD_SCHEDULE_CREATE_OTHER_VERSIONS_MENU_ITEM: 'FieldScheduleCreateOtherVersionsMenuItem',
  FIELD_SCHEDULE_CREATE_NEXT_BUTTON: 'FieldScheduleCreateNextButton',
  FIELD_SCHEDULE_SELECT_CODE_NEXT_BUTTON: 'FieldScheduleSelectCodeNextButton',
  FIELD_SCHEDULE_CREATE_PROJECT_BUTTON: 'FieldScheduleCreateProjectButton',
  FIELD_SCHEDULE_OPTIONS_PLANERA_CARD: 'FieldScheduleOptionsPlaneraCard',
  FIELD_SCHEDULE_OPTIONS_P6_CARD: 'FieldScheduleOptionsP6Card',
  FIELD_SCHEDULE_OPTIONS_STANDALONE_CARD: 'FieldScheduleOptionsStandaloneCard',
  FIELD_SCHEDULE_OPTIONS_CHANGE_BUTTON: 'FieldScheduleOptionsChangeButton',
  FIELD_SCHEDULE_OPTIONS_IMPORT_DIALOG: 'FieldScheduleOptionsImportDialog',
  MASTER_SCHEDULE_CREATE_NEXT_BUTTON: 'MasterScheduleCreateNextButton',
  MASTER_SCHEDULE_CREATE_PROJECT_BUTTON: 'MasterScheduleCreateProjectButton',
  MASTER_SCHEDULE_ORG_FIELDS_USER_INPUT: 'MasterScheduleOrgFieldsUserInput',
  MASTER_SCHEDULE_ORG_FIELDS_NUMBER_INPUT: 'MasterScheduleOrgFieldsNumberInput',
  MASTER_SCHEDULE_ORG_FIELDS_TAG_INPUT: 'MasterScheduleOrgFieldsTagInput',
  MASTER_SCHEDULE_ORG_FIELDS_SHOW_ALL_BUTTON: 'MasterScheduleOrgFieldsShowAllButton',
  MASTER_SCHEDULE_ORG_FIELDS_SHOW_LESS_BUTTON: 'MasterScheduleOrgFieldsShowLessButton',
  ORGANIZATION_FIELD_TAG_INPUT_CONTAINER: 'OrganizationFieldTagInputContainer',
  MASTER_SCHEDULE_OPTIONS_DROPDOWN_POPOVER: 'MasterScheduleOptionsDropdownPopover',
  MASTER_SCHEDULE_OPTIONS_SEARCH_INPUT: 'MasterScheduleOptionsSearchInput',
  MASTER_SCHEDULE_OPTIONS_PROJECT_ITEM: 'MasterScheduleOptionsProjectItem',
  MASTER_SCHEDULE_SELECTION_DROPDOWN: 'MasterScheduleSelectionDropdown',
  FIELD_SCHEDULE_LEARN_MORE_CONTAINER: 'FieldScheduleLearnMoreContainer',
  PROJECT_CREATE_BACK_BUTTON: 'ProjectCreateBackButton',
  PROJECT_CREATE_LEARN_MORE_BUTTON: 'ProjectCreateLearnMoreButton',
  ALL_PROJECTS_ORGANIZE_BY_BUTTON: 'AllProjectsOrganizeByButton',
  ALL_PROJECTS_ORGANIZE_BY_WIDGET: 'AllProjectsOrganizeByWidget',
  ALL_PROJECTS_ORGANIZE_BY_WIDGET_POPOVER: 'AllProjectsOrganizeByWidgetPopover',
  ALL_PROJECTS_ORGANIZE_BY_WIDGET_SWITCH_BUTTON: 'AllProjectsOrganizeByWidgetSwitchButton',
  ALL_PROJECTS_ORGANIZE_BY_WIDGET_RESTORE_DEFAULT_BUTTON: 'AllProjectsOrganizeByWidgetRestoreDefaultButton',
  ALL_PROJECTS_TABLE_ACTIONS_WRAPPER: 'AllProjectsTableActionsWrapper',
  ALL_PROJECTS_TABLE_ACTIONS_SAVE_VIEW: 'AllProjectsTableActionsSaveView',
  PROJECT_LIST_ACTIONS_WRAPPER: 'ProjectListActionsWrapper',
  PROJECT_LIST_ACTIONS_CREATE_BUTTON_WRAPPER: 'ProjectListActionsCreateButtonWrapper',
  PROJECTS_LIST_WRAPPER: 'ProjectsListWrapper',
  PROJECTS_LIST_WORKSPACES_SECTION: 'ProjectsListWorkspacesSection',
  PROJECTS_LIST_PROJECTS_SECTION: 'ProjectsListProjectsSection',
  PROJECTS_LIST_ACCESS_DIALOG: 'ProjectsListAccessDialog',
  USER_PROFILE_DIALOG: 'UserProfileDialog',
  USER_PROFILE_DIALOG_CLOSE_BUTTON: 'UserProfileDialogCloseButton',
  USER_PROFILE_DIALOG_TITLE: 'UserProfileDialogTitle',
  USER_PROFILE_DIALOG_ICON: 'UserProfileDialogIcon',
  USER_PROFILE_DIALOG_PHOTO_TEXT: 'UserProfileDialogPhotoText',
  USER_PROFILE_DIALOG_FULL_NAME_LABEL: 'UserProfileDialogFullNameLabel',
  USER_PROFILE_DIALOG_NAME_INPUT: 'UserProfileDialogNameInput',
  USER_PROFILE_DIALOG_SAVE_BUTTON: 'UserProfileDialogSaveButton',
  NEW_HOMEPAGE_LEARNING_CENTER_TITLE: 'homepageLearningCenterTitle',
  NEW_HOMEPAGE_MANNY_SECTION_TITLE: 'homepageMannySectionTitle',
  MANNY_PROMPT_LIBRARY_CARD: 'homepageMannyPromptLibraryCard',
  ALL_PROJECTS_CARD: 'homepageAllProjectsCard',
  PROJECT_PERFORMANCE_CARD: 'homepageProjectPerformanceCard',
  RESOURCE_PLANNING_CARD: 'homepageResourcePlanningCard',
  CALENDARS_CARD: 'homepageCalendarsCard',
  RESOURCE_LIBRARY_CARD: 'homepageResourceLibraryCard',
  ORGANIZATION_FIELDS_CARD: 'homepageOrganizationFieldsCard',
  ALL_USERS_CARD: 'homepageAllUsersCard',
  VARIANCE_REASONS_CARD: 'homepageVarianceReasonsCard',
  QUALITY_SCORING_CARD: 'homepageQualityScoringCard',
  PRODUCT_TUTORIALS_CARD: 'homepageProductTutorialsCard',
  HELP_ARTICLES_CARD: 'homepageHelpArticlesCard',
  PRODUCT_UPDATES_CARD: 'homepageProductUpdatesCard',
  PLANERA_MASTERCLASS_CARD: 'homepagePlaneraMasterclassCard',

  // Main sections
  CONTAINER: 'home-page-container',
  HEADER: 'home-page-header',
  CONTENT: 'home-page-content',

  // Project Too Large for iPad Page
  PROJECT_TOO_LARGE_CONTAINER: 'project-too-large-for-ipad-container',
  PROJECT_TOO_LARGE_GO_TO_PROJECTS_BUTTON: 'project-too-large-for-ipad-go-to-projects-button',

  // Organization switcher
  ORG_SWITCHER: 'home-page-org-switcher',
  ORG_SWITCHER_BUTTON: 'home-page-org-switcher-button',
  ORG_SWITCHER_MENU: 'home-page-org-switcher-menu',
  ORG_SWITCHER_ITEM: 'home-page-org-switcher-item',
  ORG_CREATE_BUTTON: 'home-page-org-create-button',
  ORG_SWITCHER_INVITE: 'home-page-org-switcher-invite',
  ORG_SWITCHER_ACCEPT: 'home-page-org-switcher-accept',
  ORG_SWITCHER_REJECT: 'home-page-org-switcher-reject',
  ORG_CREATE_DIALOG: 'home-page-org-create-dialog',
  ORG_CREATE_DIALOG_TITLE: 'home-page-org-create-dialog-title',
  ORG_CREATE_DIALOG_INPUT: 'home-page-org-create-dialog-input',
  ORG_CREATE_DIALOG_CONFIRM: 'home-page-org-create-dialog-confirm',

  // Workspace management
  WORKSPACE_CREATE_BUTTON: 'home-page-workspace-create-button',
  WORKSPACE_LIST_ITEM: 'home-page-workspace-list-item',
  WORKSPACE_MENU_BUTTON: 'home-page-workspace-menu-button',
  WORKSPACE_DELETE_BUTTON: 'home-page-workspace-delete-button',
  WORKSPACE_EDIT_BUTTON: 'home-page-workspace-edit-button',
  WORKSPACE_CREATE_BUTTON_ICON: 'home-page-workspace-create-button-icon',
  WORKSPACE_CREATE_BUTTON_TEXT: 'home-page-workspace-create-button-text',
  WORKSPACE_DELETE_BUTTON_CANCEL: 'home-page-workspace-delete-button-cancel',
  WORKSPACE_DELETE_BUTTON_CONFIRM: 'home-page-workspace-delete-button-confirm',
  WORKSPACE_LIST_ITEM_BUTTON: 'home-page-workspace-list-item-button',
  WORKSPACE_LIST_ITEM_NAME: 'home-page-workspace-list-item-name',
  WORKSPACE_LIST_ITEM_COUNT: 'home-page-workspace-list-item-count',

  // Project management
  PROJECT_CREATE_BUTTON: 'home-page-project-create-button',
  PROJECT_CARD: 'home-page-project-card',
  PROJECT_CREATE_BUTTON_ICON: 'home-page-project-create-button-icon',
  PROJECT_CREATE_BUTTON_TEXT: 'home-page-project-create-button-text',
  PROJECT_CARD_MENU: 'home-page-project-card-menu',
  PROJECT_MOVE_BUTTON: 'home-page-project-move-button',
  PROJECT_DELETE_BUTTON: 'home-page-project-delete-button',
  PROJECT_FILTER_DROPDOWN: 'home-page-project-filter-dropdown',
  PROJECT_SORT_DROPDOWN: 'home-page-project-sort-dropdown',
  PROJECT_SORT_MENU: 'home-page-project-sort-menu',
  PROJECT_SORT_OPTION: 'home-page-project-sort-option',
  PROJECT_SORT_MENU_OPTION: 'home-page-project-sort-menu-option',
  PROJECT_SEARCH_INPUT: 'home-page-project-search-input',
  PROJECT_SEARCH_ICON: 'home-page-project-search-icon',
  PROJECT_SEARCH_CLEAR: 'home-page-project-search-clear',
  PROJECT_FILTER_OPTION_NONE: 'home-page-project-filter-option-none',
  PROJECT_FILTER_OPTION_MASTER_SCHEDULE: 'home-page-project-filter-option-master-schedule',
  PROJECT_FILTER_OPTION_WORKING_SCHEDULE: 'home-page-project-filter-option-working-schedule',
  PROJECT_CARD_TITLE: 'home-page-project-card-title',
  PROJECT_CARD_ICON: 'home-page-project-card-icon',
  PROJECT_CARD_USER_AVATAR: 'home-page-project-card-user-avatar',
  PROJECT_CARD_USER_NAME: 'home-page-project-card-user-name',
  PROJECT_CARD_LAST_MODIFIED: 'home-page-project-card-last-modified',

  // User management
  USER_DROPDOWN: 'home-page-user-dropdown',
  USER_DROPDOWN_BUTTON: 'home-page-user-dropdown-button',
  USER_PROFILE_BUTTON: 'home-page-user-profile-button',
  USER_SETTINGS_BUTTON: 'home-page-user-settings-button',
  USER_LOGOUT_BUTTON: 'home-page-user-logout-button',

  // Linked projects
  LINKED_PROJECTS_DIALOG: 'home-page-linked-projects-dialog',
  LINKED_PROJECT_ITEM: 'home-page-linked-project-item',
  LINKED_CARD_CONTAINER: 'home-page-linked-card-container',
  LINKED_PROJECT_CARD: 'home-page-linked-project-card',
  LINKED_PROJECT_SCHEDULE: 'home-page-linked-project-schedule',

  // Value editor
  VALUE_EDITOR_INPUT: 'home-page-value-editor-input',
  VALUE_EDITOR_SAVE: 'home-page-value-editor-save',
  VALUE_EDITOR_CANCEL: 'home-page-value-editor-cancel',

  // Import project
  IMPORT_PROJECT_BUTTON: 'home-page-import-project-button',
  IMPORT_PROJECT_BUTTON_ICON: 'home-page-import-project-button-icon',
  IMPORT_PROJECT_BUTTON_TEXT: 'home-page-import-project-button-text',
  IMPORT_PROJECT_DIALOG: 'home-page-import-project-dialog',
  IMPORT_PROJECT_FILE_INPUT: 'home-page-import-project-file-input',

  // Recent projects
  RECENT_PROJECTS_LIST: 'home-page-recent-projects-list',
  RECENT_PROJECT_ITEM: 'home-page-recent-project-item',
  RECENT_PROJECT_ITEM_ICON: 'home-page-recent-project-item-icon',
  RECENT_PROJECT_ITEM_TEXT: 'home-page-recent-project-item-text',
  RECENT_PROJECT_ITEM_COUNT: 'home-page-recent-project-item-count',

  // LinkedProjectSchedule
  LINKED_PROJECT_SCHEDULE_COUNT: 'home-page-linked-project-schedule-count',
  LINKED_PROJECT_SCHEDULE_ICON: 'home-page-linked-project-schedule-icon',
  LINKED_PROJECT_WS_ICON: 'home-page-linked-project-ws-icon',

  // LinkedProjectsDialog
  LINKED_PROJECTS_DIALOG_CLOSE: 'home-page-linked-projects-dialog-close',
  LINKED_PROJECTS_DIALOG_TITLE: 'home-page-linked-projects-dialog-title',

  // WorkspaceNotEmptyDeleteDialog
  WORKSPACE_NOT_EMPTY_DELETE_BUTTON: 'home-page-workspace-not-empty-delete-button',

  // UsersPopover
  USERS_POPOVER: 'home-page-users-popover',
  USERS_POPOVER_TITLE: 'home-page-users-popover-title',
  USERS_POPOVER_USER: 'home-page-users-popover-user',
  USERS_POPOVER_USER_AVATAR: 'home-page-users-popover-user-avatar',
  USERS_POPOVER_USER_NAME: 'home-page-users-popover-user-name',
  USERS_POPOVER_USER_ROLE: 'home-page-users-popover-user-role'
} as const;
